import React from 'react';
import styled from '@emotion/styled';
import { getTextColor, getTextType, type } from '../style';
import { isDarkMode, ternaryFunc } from '../utils/helpers';
import ProfileEditButtonV2 from '../atoms/buttons/ProfileEditButtonV2';
import breakpoints from '../theme/material/breakpoints';
import VerifiedBadgeTooltip from '../components/common/VerifiedBadgeTooltip';
import { FONT_FAMILIES } from 'theme/material/constants';

const Details = styled('div')({
  width: '100%',
  [breakpoints.down(620.05)]: {
    padding: '0 15px',
  },
});

const Username = styled('h1')(() => ({
  margin: 0,
  paddingBottom: 4,
  ...type.title.MD,
  letterSpacing: -0.3,
  fontWeight: 400,
  lineHeight: 'normal',
  fontFamily: FONT_FAMILIES.secondary,
  color: !isDarkMode() ? '#212121' : '#FFFFFF',
  [breakpoints.down(620.05)]: {
    color: '#fff',
    ...type.title.SM,
    letterSpacing: -0.2,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
}));

const VerifiedBadgeWrapper = styled('span')({
  marginLeft: 4,
  position: 'relative',
  top: 6,
  [breakpoints.down(768.05)]: {
    top: 4,
  },
});

const Detail = styled('div')(() => ({
  margin: 0,
  ...getTextType().text,
  lineHeight: '21px',
  letterSpacing: -0.3,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: 350,
  ...getTextColor().DARK_2,
  [breakpoints.between(621, 634)]: {
    width: '100%',
  },

  whiteSpace: 'nowrap',
  [breakpoints.down(620.05)]: {
    fontSize: 14,
    fontWeight: 400,
    color: '#AFB0B1',
    lineHeight: 'normal',
    whiteSpace: 'unset',
    overflow: 'unset',
  },
}));

const ProfileEditButtonWrapper = styled('span')({
  [breakpoints.down(620.05)]: {
    display: 'none',
  },
});
const MobileProfileEditButtonWrapper = styled('span')({
  display: 'none',
  [breakpoints.down(620.05)]: {
    display: 'inline-block',
    verticalAlign: 'bottom',
  },
});

const MyProfileCoverInfo = ({
  displayName,
  auth10tixVerification,
  isVerified,
  age,
  toggleEditable,
  setMyCurrLocation,
  editable,
  freshLocation,
  myLocation,
  isSelfieVerified,
}: any): any => {
  return (
    <>
      <Details>
        <Username data-test-id="profile-username-info">
          {displayName}
          {((auth10tixVerification && isVerified) || isSelfieVerified) && (
            <VerifiedBadgeWrapper>
              <VerifiedBadgeTooltip showToolTip={true} isSelfieVerified={isSelfieVerified} isIdVerified={isVerified} />
            </VerifiedBadgeWrapper>
          )}
          {editable && (
            <ProfileEditButtonWrapper>
              <ProfileEditButtonV2
                dataTestId="edit-profile-cover"
                id="edit-profile-cover"
                handleClick={toggleEditable}
                customStyle={{
                  float: 'right',
                }}
              />
            </ProfileEditButtonWrapper>
          )}
        </Username>
        <Detail data-test-id="profile-user-details">
          {age}
          {setMyCurrLocation()}
          {ternaryFunc(editable, freshLocation, myLocation)}
          {editable && (
            <MobileProfileEditButtonWrapper>
              <ProfileEditButtonV2
                dataTestId="edit-profile-cover"
                id="edit-profile-cover"
                handleClick={toggleEditable}
                customStyle={{
                  float: 'right',
                }}
              />
            </MobileProfileEditButtonWrapper>
          )}
        </Detail>
      </Details>
    </>
  );
};

export default React.memo(MyProfileCoverInfo);
